<h3 class="text-white">
    {{ 'LOGIN.ENTER_NEW_PASSWORD' | translate }}
</h3>

<form [formGroup]="changePasswordForm">

    <!-- Password -->

    <password placeholder="LOGIN.ENTER_PASSWORD" controlName="Password" class="p-field w-full my-2"
        [action]="changePassword.bind(this)" (passwordChanged)="onPasswordChanged()"></password>

    <!-- Confirm Password -->

    <div class="my-2">
        <password placeholder="LOGIN.CONFIRM_PASSWORD" controlName="PasswordConfirm" class="p-field w-full my-2"
            [action]="changePassword.bind(this)"></password>
    </div>


</form>